import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from "react-redux";
import store from './redux/store'
import App from './App';
import './index.css';
import axios from "axios";
import {setAuthenticated, setLoading} from "./redux/userSlice";

// any 401, dispatch unauthorized, then we dont need to pass dispatch to service calls
const UNAUTHORIZED = 401;
const {dispatch} = store;
axios.interceptors.response.use(
    response=> response,
    error => {
        const {status} = error.response;
        if (status === UNAUTHORIZED) {
            dispatch(setAuthenticated(false));
            dispatch(setLoading(false));
            // any reason to nuke user state here? just make them reauthenticate
        }
        return Promise.reject(error);
    }
);

ReactDOM.render(
  <React.StrictMode>
      <Provider store={store} >
          <App />
      </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
